// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__fOuCI","signatureButtonsRight":"ModalSign_signatureButtonsRight__10eNy"};